// Extract hostname (e.g., "localhost", "sis.ivyis.org", "ics.ivyis.org")
const hostname = window.location.hostname;

let domain = "";
let BASE_URL = "";
let PUBLIC_URL = "";


if (hostname.includes("localhost")) {
  domain = "localhost";
  BASE_URL = "https://localhost/survey/backend";
  PUBLIC_URL = "https://localhost/survey";

} else {
  domain = hostname.split(".").slice(-2).join(".");
  BASE_URL = `https://${hostname}/backend`;
    PUBLIC_URL = `https://${hostname}`;

}

export {
  BASE_URL,
  domain,
  PUBLIC_URL
 
};
